import {
  cancelSubscription
} from "./chunk-DRIP5NSH.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/subscriptions/cancel.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: (_, { subscriptionId }) => {
      queryClient.setQueriesData({ queryKey: ["user"] }, (oldUser) => {
        var _a;
        if (!oldUser)
          return oldUser;
        return __spreadProps(__spreadValues({}, oldUser), {
          user_subscriptions: (_a = oldUser == null ? void 0 : oldUser.user_subscriptions) == null ? void 0 : _a.map((s) => {
            return s._id === subscriptionId ? __spreadProps(__spreadValues({}, s), { is_cancelled: true }) : s;
          })
        });
      });
    }
  });
};

export {
  useCancelSubscription
};
//# sourceMappingURL=chunk-7OQMZJJ2.mjs.map